import ARAdministrador from '../../views/administrador/Index.vue';
import ARAMeusDados from '../../views/administrador/MeusDados.vue';
import ARLCotRecebida from '../../views/administrador/CotacaoRecebida.vue';
import ProfessionalPlans from '../../views/administrador/ProfessionalPlans.vue';
import LojistasPlans from '../../views/administrador/LojistaPlans.vue';
import LojistaAssinatura from '../../views/administrador/LojistaAssinatura.vue';
import ProfissionalAssinatura from '../../views/administrador/ProfissionalAssinatura.vue';
import LojistasPlansUpload from '../../views/administrador/LojistasPlansUpload.vue';
import LojistasPlansCupons from '../../views/administrador/LojistasCupons.vue';
import ARACriaEstados from '../../views/administrador/CriaEstados.vue';
import ARAListaEstados from '../../views/administrador/ListaEstados.vue';
import ARAEditarEstado from '../../views/administrador/EditarEstado.vue';
import ARAVerEstado from '../../views/administrador/VerEstado.vue';
import EmailLojista from '../../views/administrador/quote/EmailLojista.vue';
import CotacaoLojista from '../../views/administrador/quote/CotacaoLojista.vue';
import ARACriaCidades from '../../views/administrador/CriaCidades.vue';
import ARAListaCidades from '../../views/administrador/ListaCidades.vue';
import ARAEditarCidade from '../../views/administrador/EditarCidade.vue';
import ARAVerCidade from '../../views/administrador/VerCidade.vue';
import ARACriaDicas from '../../views/administrador/CriaDicas.vue';
import ARAListaDicas from '../../views/administrador/ListaDicas.vue';
import ARAEditarDica from '../../views/administrador/EditarDica.vue';
import ARAVerDica from '../../views/administrador/VerDica.vue';
import ARACriaProduto from '../../views/administrador/CriaProduto.vue';
import ARAListaProdutos from '../../views/administrador/ListaProdutos.vue';
import ARAEditarProduto from '../../views/administrador/EditarProduto.vue';
import ARAVerProduto from '../../views/administrador/VerProduto.vue';
import ARACriaSegmento from '../../views/administrador/CriaSegmento.vue';
import ARAListaSegmentos from '../../views/administrador/ListaSegmentos.vue';
import ARAEditarSegmento from '../../views/administrador/EditarSegmento.vue';
import ARAVerSegmento from '../../views/administrador/VerSegmento.vue';
import ARACriaProfissao from '../../views/administrador/CriaProfissoes.vue';
import ARAListaProfissao from '../../views/administrador/ListaProfissoes.vue';
import ARAEditarProfissao from '../../views/administrador/EditarProfissao.vue';
import ARAVerProfissao from '../../views/administrador/VerProfissao.vue';
import ARACriaMedidas from '../../views/administrador/CriaMedidas.vue';
import ARAListaMedidas from '../../views/administrador/ListaMedidas.vue';
import ARAEditarMedidas from '../../views/administrador/EditarMedidas.vue';
import ARAVerMedidas from '../../views/administrador/VerMedidas.vue';
import ARACriaMarca from '../../views/administrador/CriaMarca.vue';
import ARAListaMarcas from '../../views/administrador/ListaMarcas.vue';
import ARAEditarMarca from '../../views/administrador/EditarMarca.vue';
import ARAVerMarca from '../../views/administrador/VerMarca.vue';
import ARAVerPedidosContratos from '../../views/administrador/VerPedidosContratos.vue';
import ARAVerPedidoContrato from '../../views/administrador/VerPedidoContrato.vue';
import ARAListaBanners from '../../views/administrador/banner/List.vue';
import EditImagensApp from '../../views/administrador/imagens/EditCategoriaApp.vue';
import EditImagensProductApp from '../../views/administrador/imagens/EditImageProductApp.vue';
import EditBanner from '../../views/administrador/banner/Edit.vue';
import ARAVerBanner from '../../views/administrador/banner/See.vue';
import ARAVerUsuarios from '../../views/administrador/Usuarios.vue';
import ARAVerResultados from '../../views/administrador/Resultados.vue';
import ARAVerGeral from '../../views/administrador/Geral.vue';
import ARAVerRelatorioLojista from '../../views/administrador/RelatorioLojista.vue';
import ARAVerRelatorioRepresentante from '../../views/administrador/RelatorioRepresentante.vue';
import ARAClientes from '../../views/administrador/Clientes.vue';
import ARAVerCliente from '../../views/administrador/VerCliente.vue';
import ARAEditarCliente from '../../views/administrador/EditarCliente.vue';
import ARAProfissionais from '../../views/administrador/Profissionais.vue';
import ARAProfissionaisGratuito from '../../views/administrador/ProfissionaisGratuito.vue';
import ARAProfissionaisBronze from '../../views/administrador/ProfissionaisBronze.vue';
import ARAProfissionaisPrata from '../../views/administrador/ProfissionaisPrata.vue';
import ARAProfissionaisOuro from '../../views/administrador/ProfissionaisOuro.vue';
import ARAProfissionaisDiamante from '../../views/administrador/ProfissionaisDiamante.vue';
import ARAVerProfissional from '../../views/administrador/VerProfissional.vue';
import ARAEditarProfissional from '../../views/administrador/EditarProfissional.vue';
import ARALojistas from '../../views/administrador/Lojistas.vue';
import ARAVerLojistas from '../../views/administrador/VerLojista.vue';
import ARAEditarLojistas from '../../views/administrador/EditarLojista.vue';
import ARARepresentantes from '../../views/administrador/Representantes.vue';
import ARAParceiros from '../../views/administrador/Parceiros.vue';
import ARAParceirosExternos from '../../views/administrador/ParceirosExternos.vue';
import ARAVerRepresentantes from '../../views/administrador/VerRepresentante.vue';
import ARAEditarRepresentantes from '../../views/administrador/EditarRepresentante.vue';
import ARAVerParceiros from '../../views/administrador/partner/SeePartner.vue';
import ARAEditarParceiros from '../../views/administrador/partner/EditPartner.vue';
import AllQuotes from '../../views/administrador/quote/AllQuotes.vue';
import QuotesCanceleds from '../../views/administrador/quote/QuotesCanceleds.vue';
import QuotesCanceledsDetails from '../../views/administrador/quote/QuotesCanceledsDetails.vue';
import ARACotacaoUnica from '../../views/administrador/CotacaoUnica.vue';
import ARACotacaoResposta from '../../views/administrador/CotacaoResposta.vue';
import ARAInicioPage from '../../views/administrador/InicioPage.vue';
import ARAComoParticiparPage from '../../views/administrador/ComoParticiparPage.vue';
import Ranking from '../../views/partner/Ranking.vue';
import RankingExterno from '../../views/partner/RankingExterno.vue';
import WhatsApp from '../../views/administrador/WhatsApp.vue';
import ListConstruBotWhatsapp from '../../views/administrador/ListConstruBotWhatsapp.vue';
import AppConfigs from '../../views/administrador/AppConfigs.vue';
import ListNotificationWhatsapp from '../../views/lojista/notifications/WhatsAppAdmin.vue';
import WhatsAppAdminConstrup from '../../views/lojista/notifications/WhatsAppAdminConstrup.vue';
import ContactClient from '../../views/administrador/ContactClient.vue';
import WhatsAppDisparar from '../../views/administrador/DispararWhatsApp.vue';
import ARALojistasLink from '../../views/partner/LojistasPorLink.vue';

import IndicatedProfessionals from '../../views/administrador/professional/IndicatedProfessionals.vue';
import ReportProfessionals from '../../views/administrador/professional/ReportProfessionals.vue';

import PedidosRecomendacoes from '../../views/administrador/PedidosRecomendacoes.vue';

import Affiliates from '../../views/administrador/affiliate/Affiliates.vue';
import UnvaluedAffiliates from '../../views/administrador/affiliate/UnvaluedAffiliates.vue';
import SeeAffiliate from '../../views/administrador/affiliate/SeeAffiliate.vue';
import EditAffiliate from '../../views/administrador/affiliate/EditAffiliate.vue';
import PendingBillet from '../../views/administrador/affiliate/PendingBillets.vue';

import UserTypes from '../../enums/UserTypes';

import ShopkeeperAppVersion from '../../views/administrador/AppVersion.vue';
import DeletePhotoProduct from '../../views/administrador/DeletePhotoProduct.vue';

import ProfissionalSiteSolicitations from '../../views/administrador/professional/SolicitationsSite.vue';
import ShopkeeperAppSolicitations from '../../views/administrador/shopkeeper-app/Solicitations.vue';
import Clients from '../../views/administrador/shopkeeper-app/clients/List.vue';
import OrdersList from '../../views/administrador/shopkeeper-app/orders/List.vue';
import OrdersStatusList from '../../views/administrador/shopkeeper-app/orders/StatusList.vue';
import SelectedProducts from '../../views/administrador/shopkeeper-app/products/SelectedProducts.vue';
import SpreadsheetToImportList from '../../views/administrador/shopkeeper-app/spreadsheets-to-import/List.vue';
import SpreadsheetToImportExcel from '../../views/administrador/shopkeeper-app/spreadsheets-to-import/importarexcel.vue';
import SpreadsheetToImportExcelIa from '../../views/administrador/shopkeeper-app/spreadsheets-to-import/importarexcelIa.vue';
import ImportClientsExcel from '../../views/administrador/shopkeeper-app/spreadsheets-to-import/ImportClientsExcel.vue';
import AdministradorEnviarWhatsappExcel from '../../views/administrador/shopkeeper-app/EnviarWhatsappExcel.vue';
import AdministradorEnviarWhatsappAudio from '../../views/administrador/shopkeeper-app/EnviarWhatsappAudio.vue';
import AdministradorConversasWhatsapp from '../../views/administrador/shopkeeper-app/ConversasWhatsapp.vue';
import ProdutosSugeridos from '../../views/administrador/shopkeeper-app/produtosSugeridos/List.vue';
import ProdutosAprovacao from '../../views/administrador/ProdutosAprovacao.vue';
import EditarLojistaProduto from '../../views/administrador/ProdutosEditarLojista.vue';
import EditarProdutos from '../../views/administrador/EditarProdutos.vue';
import LogListClerk from '../../views/administrador/clerk/LogListClerk.vue';
import ARAGerenteVendas from '../../views/administrador/gerenteVendas/Index.vue';
import RaffleCampaignIndex from '../../views/administrador/raffleCampaign/Index.vue';

export default [
  {
    path: '/area-restrita/administrador',
    name: 'administrador',
    component: ARAdministrador,
    children: [
      {
        path: '/area-restrita/administrador/meus-dados',
        name: 'administrador-meus-dados',
        component: ARAMeusDados,
        meta: { userType: UserTypes.ADMINISTRATOR },
      },
      {
        path: '/area-restrita/administrador/planos-profissionais',
        name: 'administrador-planos-profissionais',
        component: ProfessionalPlans,
        meta: { userType: UserTypes.ADMINISTRATOR },
      },
      {
        path: '/area-restrita/administrador/assinatura-planos-app',
        name: 'administrador-assinatura-planos-app',
        component: LojistaAssinatura,
        meta: { userType: UserTypes.ADMINISTRATOR },
      },
      {
        path: '/area-restrita/administrador/assinatura-planos-profissional',
        name: 'administrador-assinatura-planos-profissional',
        component: ProfissionalAssinatura,
        meta: { userType: UserTypes.ADMINISTRATOR },
      },
      {
        path: '/area-restrita/administrador/planos-artes-rede-social',
        name: 'administrador-planos-redes-sociais',
        component: LojistasPlans,
        meta: { userType: UserTypes.ADMINISTRATOR },
      },
      {
        path: '/area-restrita/administrador/upload-imagens-plano',
        name: 'administrador-upload-plano',
        component: LojistasPlansUpload,
        meta: { userType: UserTypes.ADMINISTRATOR },
      },
      {
        path: '/area-restrita/administrador/cupons-plano',
        name: 'administrador-cupons-planos',
        component: LojistasPlansCupons,
        meta: { userType: UserTypes.ADMINISTRATOR },
      },
      {
        path: '/area-restrita/administrador/cria-estados',
        name: 'administrador-cria-estados',
        component: ARACriaEstados,
        meta: { userType: UserTypes.ADMINISTRATOR },
      },
      {
        path: '/area-restrita/administrador/cotacao/recebida/:id/:idLojista',
        name: 'administrador-cotacao-recebida',
        props: true,
        component: ARLCotRecebida,
        meta: { userType: UserTypes.ADMINISTRATOR },
      },
      {
        path: '/area-restrita/administrador/campanha-sorteio',
        name: 'administrador-app-sorteios',
        props: true,
        component: RaffleCampaignIndex,
        meta: { userType: UserTypes.ADMINISTRATOR },
      },
      {
        path: '/area-restrita/administrador/cotacao-lojista/:id',
        name: 'administrador-cotacao-lojista',
        component: CotacaoLojista,
        meta: { userType: UserTypes.ADMINISTRATOR },
      },
      {
        path: '/area-restrita/administrador/lista-estados',
        name: 'administrador-lista-estados',
        component: ARAListaEstados,
        meta: { userType: UserTypes.ADMINISTRATOR },
      },
      {
        path: '/area-restrita/administrador/editar-estado/:id',
        name: 'administrador-editar-estado',
        props: true,
        component: ARAEditarEstado,
        meta: { userType: UserTypes.ADMINISTRATOR },
      },
      {
        path: '/area-restrita/administrador/ver-estado/:id',
        name: 'administrador-ver-estado',
        props: true,
        component: ARAVerEstado,
        meta: { userType: UserTypes.ADMINISTRATOR },
      },
      {
        path: '/area-restrita/administrador/cria-cidades',
        name: 'administrador-cria-cidades',
        component: ARACriaCidades,
        meta: { userType: UserTypes.ADMINISTRATOR },
      },
      {
        path: '/area-restrita/administrador/lista-cidades',
        name: 'administrador-lista-cidades',
        component: ARAListaCidades,
        meta: { userType: UserTypes.ADMINISTRATOR },
      },
      {
        path: '/area-restrita/administrador/editar-cidade/:id',
        name: 'administrador-editar-cidade',
        props: true,
        component: ARAEditarCidade,
        meta: { userType: UserTypes.ADMINISTRATOR },
      },
      {
        path: '/area-restrita/administrador/ver-cidade/:id',
        name: 'administrador-ver-cidade',
        props: true,
        component: ARAVerCidade,
        meta: { userType: UserTypes.ADMINISTRATOR },
      },
      {
        path: '/area-restrita/administrador/cria-dicas',
        name: 'administrador-cria-dicas',
        component: ARACriaDicas,
        meta: { userType: UserTypes.ADMINISTRATOR },
      },
      {
        path: '/area-restrita/administrador/lista-dicas',
        name: 'administrador-lista-dicas',
        component: ARAListaDicas,
        meta: { userType: UserTypes.ADMINISTRATOR },
      },
      {
        path: '/area-restrita/administrador/editar-dica/:id',
        name: 'administrador-editar-dica',
        props: true,
        component: ARAEditarDica,
        meta: { userType: UserTypes.ADMINISTRATOR },
      },
      {
        path: '/area-restrita/administrador/ver-dica/:id',
        name: 'administrador-ver-dica',
        props: true,
        component: ARAVerDica,
        meta: { userType: UserTypes.ADMINISTRATOR },
      },
      {
        path: '/area-restrita/administrador/email-lojista',
        name: 'administrador-email-lojista',
        component: EmailLojista,
        meta: { userType: UserTypes.ADMINISTRATOR },
      },
      {
        path: '/area-restrita/administrador/cria-produtos',
        name: 'administrador-cria-produtos',
        component: ARACriaProduto,
        meta: { userType: UserTypes.ADMINISTRATOR },
      },
      {
        path: '/area-restrita/administrador/lista-produtos',
        name: 'administrador-lista-produtos',
        component: ARAListaProdutos,
        meta: { userType: UserTypes.ADMINISTRATOR },
      },
      {
        path: '/area-restrita/administrador/editar-produto/:id',
        name: 'administrador-editar-produto',
        props: true,
        component: ARAEditarProduto,
        meta: { userType: UserTypes.ADMINISTRATOR },
      },
      {
        path: '/area-restrita/administrador/ver-produto/:id',
        name: 'administrador-ver-produto',
        props: true,
        component: ARAVerProduto,
        meta: { userType: UserTypes.ADMINISTRATOR },
      },
      {
        path: '/area-restrita/administrador/cria-seguimentos',
        name: 'administrador-cria-segmentos',
        component: ARACriaSegmento,
        meta: { userType: UserTypes.ADMINISTRATOR },
      },
      {
        path: '/area-restrita/administrador/lista-seguimentos',
        name: 'administrador-lista-segmentos',
        component: ARAListaSegmentos,
        meta: { userType: UserTypes.ADMINISTRATOR },
      },
      {
        path: '/area-restrita/administrador/editar-seguimentos/:id',
        name: 'administrador-editar-segmento',
        props: true,
        component: ARAEditarSegmento,
        meta: { userType: UserTypes.ADMINISTRATOR },
      },
      {
        path: '/area-restrita/administrador/ver-seguimentos/:id',
        name: 'administrador-ver-segmento',
        props: true,
        component: ARAVerSegmento,
        meta: { userType: UserTypes.ADMINISTRATOR },
      },
      {
        path: '/area-restrita/administrador/cria-profissoes',
        name: 'administrador-cria-profissoes',
        component: ARACriaProfissao,
        meta: { userType: UserTypes.ADMINISTRATOR },
      },
      {
        path: '/area-restrita/administrador/lista-profissoes',
        name: 'administrador-lista-profissoes',
        component: ARAListaProfissao,
        meta: { userType: UserTypes.ADMINISTRATOR },
      },
      {
        path: '/area-restrita/administrador/editar-profissoes/:id',
        name: 'administrador-editar-profissoes',
        props: true,
        component: ARAEditarProfissao,
        meta: { userType: UserTypes.ADMINISTRATOR },
      },
      {
        path: '/area-restrita/administrador/ver-profissoes/:id',
        name: 'administrador-ver-profissoes',
        props: true,
        component: ARAVerProfissao,
        meta: { userType: UserTypes.ADMINISTRATOR },
      },
      {
        path: '/area-restrita/administrador/cria-produto-marca',
        name: 'administrador-cria-produto-marca',
        component: ARACriaMarca,
        meta: { userType: UserTypes.ADMINISTRATOR },
      },
      {
        path: '/area-restrita/administrador/lista-produto-marca',
        name: 'administrador-lista-produto-marca',
        component: ARAListaMarcas,
        meta: { userType: UserTypes.ADMINISTRATOR },
      },
      {
        path: '/area-restrita/administrador/editar-produto-marca/:id',
        name: 'administrador-editar-produto-marca',
        props: true,
        component: ARAEditarMarca,
        meta: { userType: UserTypes.ADMINISTRATOR },
      },
      {
        path: '/area-restrita/administrador/ver-produto-marca/:id',
        name: 'administrador-ver-produto-marca',
        props: true,
        component: ARAVerMarca,
        meta: { userType: UserTypes.ADMINISTRATOR },
      },
      {
        path: '/area-restrita/administrador/ver-pedidos-contratos',
        name: 'administrador-ver-pedidos-contratos',
        component: ARAVerPedidosContratos,
        meta: { userType: UserTypes.ADMINISTRATOR },
      },
      {
        path: '/area-restrita/administrador/ver-pedido-contrato/:id',
        name: 'administrador-ver-pedido-contrato',
        props: true,
        component: ARAVerPedidoContrato,
        meta: { userType: UserTypes.ADMINISTRATOR },
      },
      {
        path: '/area-restrita/administrador/lista-banners',
        name: 'administrador-lista-banners',
        component: ARAListaBanners,
        meta: { userType: UserTypes.ADMINISTRATOR },
      },
      {
        path: '/area-restrita/administrador/banner/:bannerId?',
        name: 'administrador-edita-banners',
        component: EditBanner,
        meta: { userType: UserTypes.ADMINISTRATOR },
      },
      {
        path: '/area-restrita/administrador/cria-medidas',
        name: 'administrador-cria-medidas',
        component: ARACriaMedidas,
        meta: { userType: UserTypes.ADMINISTRATOR },
      },
      {
        path: '/area-restrita/administrador/editar-medidas/:id',
        name: 'administrador-editar-medidas',
        props: true,
        component: ARAEditarMedidas,
        meta: { userType: UserTypes.ADMINISTRATOR },
      },
      {
        path: '/area-restrita/administrador/ver-medidas/:id',
        name: 'administrador-ver-medidas',
        props: true,
        component: ARAVerMedidas,
        meta: { userType: UserTypes.ADMINISTRATOR },
      },
      {
        path: '/area-restrita/administrador/lista-medidas',
        name: 'administrador-lista-medidas',
        component: ARAListaMedidas,
        meta: { userType: UserTypes.ADMINISTRATOR },
      },
      {
        path: '/area-restrita/administrador/ver-banner/:id',
        name: 'administrador-ver-banner',
        props: true,
        component: ARAVerBanner,
        meta: { userType: UserTypes.ADMINISTRATOR },
      },
      {
        path: '/area-restrita/administrador/ver-usuarios',
        name: 'administrador-ver-usuarios',
        component: ARAVerUsuarios,
        meta: { userType: UserTypes.ADMINISTRATOR },
      },
      {
        path: '/area-restrita/administrador/ver-geral',
        name: 'administrador-ver-geral',
        component: ARAVerGeral,
        meta: { userType: UserTypes.ADMINISTRATOR },
      },
      {
        path: '/area-restrita/administrador/ver-resultados',
        name: 'administrador-ver-resultados',
        component: ARAVerResultados,
        meta: { userType: UserTypes.ADMINISTRATOR },
      },
      {
        path: '/area-restrita/administrador/ver-relatorio-lojista/:id',
        name: 'administrador-ver-relatorio-lojista',
        props: true,
        component: ARAVerRelatorioLojista,
        meta: { userType: UserTypes.ADMINISTRATOR },
      },
      {
        path: '/area-restrita/administrador/ver-relatorio-representante/:id',
        name: 'administrador-ver-relatorio-representante',
        props: true,
        component: ARAVerRelatorioRepresentante,
        meta: { userType: UserTypes.ADMINISTRATOR },
      },
      {
        path: '/area-restrita/administrador/clientes',
        name: 'administrador-clientes',
        component: ARAClientes,
        meta: { userType: UserTypes.ADMINISTRATOR },
      },
      {
        path: '/area-restrita/administrador/ver-cliente/:id',
        name: 'administrador-ver-cliente',
        props: true,
        component: ARAVerCliente,
        meta: { userType: UserTypes.ADMINISTRATOR },
      },
      {
        path: '/area-restrita/administrador/editar-cliente/:id',
        name: 'administrador-editar-cliente',
        props: true,
        component: ARAEditarCliente,
        meta: { userType: UserTypes.ADMINISTRATOR },
      },
      {
        path: '/area-restrita/administrador/profissionais',
        name: 'administrador-profissionais',
        component: ARAProfissionais,
        meta: { userType: UserTypes.ADMINISTRATOR },
      },
      {
        path: '/area-restrita/administrador/profissionais-gratuito',
        name: 'administrador-profissionais-gratuito',
        component: ARAProfissionaisGratuito,
        meta: { userType: UserTypes.ADMINISTRATOR },
      },
      {
        path: '/area-restrita/administrador/profissionais-bronze',
        name: 'administrador-profissionais-bronze',
        component: ARAProfissionaisBronze,
        meta: { userType: UserTypes.ADMINISTRATOR },
      },
      {
        path: '/area-restrita/administrador/profissionais-prata',
        name: 'administrador-profissionais-prata',
        component: ARAProfissionaisPrata,
        meta: { userType: UserTypes.ADMINISTRATOR },
      },
      {
        path: '/area-restrita/administrador/profissionais-ouro',
        name: 'administrador-profissionais-ouro',
        component: ARAProfissionaisOuro,
        meta: { userType: UserTypes.ADMINISTRATOR },
      },
      {
        path: '/area-restrita/administrador/profissionais-diamante',
        name: 'administrador-profissionais-diamante',
        component: ARAProfissionaisDiamante,
        meta: { userType: UserTypes.ADMINISTRATOR },
      },
      {
        path: '/area-restrita/administrador/profissionais/indicados',
        name: 'administrador-profissionais-indicados',
        component: IndicatedProfessionals,
        meta: { userType: UserTypes.ADMINISTRATOR },
      },
      {
        path: '/area-restrita/administrador/profissionais/denuncias',
        name: 'administrador-profissionais-denuncias',
        component: ReportProfessionals,
        meta: { userType: UserTypes.ADMINISTRATOR },
      },
      {
        path: '/area-restrita/administrador/ver-profissional/:id',
        name: 'administrador-ver-profissional',
        props: true,
        component: ARAVerProfissional,
        meta: { userType: UserTypes.ADMINISTRATOR },
      },
      {
        path: '/area-restrita/administrador/editar-profissional/:id',
        name: 'administrador-editar-profissional',
        props: true,
        component: ARAEditarProfissional,
        meta: { userType: UserTypes.ADMINISTRATOR },
      },
      {
        path: '/area-restrita/administrador/lojistas',
        name: 'administrador-lojistas',
        component: ARALojistas,
        meta: { userType: UserTypes.ADMINISTRATOR },
      },
      {
        path: '/area-restrita/administrador/ver-lojista/:id',
        name: 'administrador-ver-lojista',
        props: true,
        component: ARAVerLojistas,
        meta: { userType: UserTypes.ADMINISTRATOR },
      },
      {
        path: '/area-restrita/administrador/editar-lojista/:id',
        name: 'administrador-editar-lojista',
        props: true,
        component: ARAEditarLojistas,
        meta: { userType: UserTypes.ADMINISTRATOR },
      },
      {
        path: '/area-restrita/administrador/representantes',
        name: 'administrador-representantes',
        component: ARARepresentantes,
        meta: { userType: UserTypes.ADMINISTRATOR },
      },
      {
        path: '/area-restrita/administrador/parceiros',
        name: 'administrador-parceiros',
        component: ARAParceiros,
        meta: { userType: UserTypes.ADMINISTRATOR },
      },
      {
        path: '/area-restrita/administrador/parceiros-externos',
        name: 'administrador-parceiros-externos',
        component: ARAParceirosExternos,
        meta: { userType: UserTypes.ADMINISTRATOR },
      },
      {
        path: '/area-restrita/administrador/ver-parceiros/:id',
        name: 'administrador-ver-parceiros',
        props: true,
        component: ARAVerParceiros,
        meta: { userType: UserTypes.ADMINISTRATOR },
      },
      {
        path: '/area-restrita/administrador/editar-parceiros/:id',
        name: 'administrador-editar-parceiros',
        props: true,
        component: ARAEditarParceiros,
        meta: { userType: UserTypes.ADMINISTRATOR },
      },
      {
        path: '/area-restrita/administrador/ver-representante/:id',
        name: 'administrador-ver-representante',
        props: true,
        component: ARAVerRepresentantes,
        meta: { userType: UserTypes.ADMINISTRATOR },
      },
      {
        path: '/area-restrita/administrador/editar-representante/:id',
        name: 'administrador-editar-representante',
        props: true,
        component: ARAEditarRepresentantes,
        meta: { userType: UserTypes.ADMINISTRATOR },
      },
      {
        path: '/area-restrita/administrador/afiliados',
        name: 'administrador-afiliados',
        component: Affiliates,
        meta: { userType: UserTypes.ADMINISTRATOR },
      },
      {
        path: '/area-restrita/administrador/afiliados/nao-avaliados',
        name: 'administrador-afiliados-nao-avaliados',
        component: UnvaluedAffiliates,
        meta: { userType: UserTypes.ADMINISTRATOR },
      },
      {
        path: '/area-restrita/administrador/gerente/recomendacoes',
        name: 'administrador-gerente-recomendacoes',
        component: PedidosRecomendacoes,
        meta: { userType: UserTypes.ADMINISTRATOR },
      },
      {
        path: '/area-restrita/administrador/afiliados/ver/:id',
        name: 'administrador-ver-afiliado',
        props: true,
        component: SeeAffiliate,
        meta: { userType: UserTypes.ADMINISTRATOR },
      },
      {
        path: '/area-restrita/administrador/afiliados/avaliar/:id',
        name: 'administrador-avaliar-afiliado',
        props: true,
        component: SeeAffiliate,
        meta: { userType: UserTypes.ADMINISTRATOR },
      },
      {
        path: '/area-restrita/administrador/afiliados/editar/:id',
        name: 'administrador-editar-afiliado',
        props: true,
        component: EditAffiliate,
        meta: { userType: UserTypes.ADMINISTRATOR },
      },
      {
        path: '/area-restrita/administrador/afiliados/boletos',
        name: 'administrador-afiliado-boletos',
        props: true,
        component: PendingBillet,
        meta: { userType: UserTypes.ADMINISTRATOR },
      },
      {
        path: '/area-restrita/administrador/cotacoes-geral',
        name: 'administrador-cotacoes-geral',
        component: AllQuotes,
        meta: { userType: UserTypes.ADMINISTRATOR },
      },
      {
        path: '/area-restrita/administrador/cotacoes-canceladas',
        name: 'administrador-cotacoes-canceladas',
        component: QuotesCanceleds,
        meta: { userType: UserTypes.ADMINISTRATOR },
      },
      {
        path: '/area-restrita/administrador/cotacoes-detalhes/:id',
        name: 'administrador-cotacoes-detalhes',
        component: QuotesCanceledsDetails,
        meta: { userType: UserTypes.ADMINISTRATOR },
      },
      {
        path: '/area-restrita/administrador/cotacao/:id',
        name: 'administrador-cotacao',
        props: true,
        component: ARACotacaoUnica,
        meta: { userType: UserTypes.ADMINISTRATOR },
      },
      {
        path: '/area-restrita/administrador/cotacoes-resposta/:id',
        name: 'administrador-cotacoes-resposta',
        props: true,
        component: ARACotacaoResposta,
        meta: { userType: UserTypes.ADMINISTRATOR },
      },
      {
        path: '/area-restrita/administrador/inicio-page',
        name: 'administrador-inicio-page',
        component: ARAInicioPage,
        meta: { userType: UserTypes.ADMINISTRATOR },
      },
      {
        path: '/area-restrita/administrador/editar-imagens-categoria-app',
        name: 'editar-imagens-categoria-app',
        component: EditImagensApp,
        meta: { userType: UserTypes.ADMINISTRATOR },
      },
      {
        path: '/area-restrita/administrador/editar-imagens-produto-app',
        name: 'editar-imagens-produto-app',
        component: EditImagensProductApp,
        meta: { userType: UserTypes.ADMINISTRATOR },
      },
      {
        path: '/area-restrita/administrador/participar-page',
        name: 'administrador-participar-page',
        component: ARAComoParticiparPage,
        meta: { userType: UserTypes.ADMINISTRATOR },
      },
      {
        path: '/area-restrita/administrador/ranking-parceiros',
        name: 'administrador-ranking-parceiros',
        component: Ranking,
        meta: { userType: UserTypes.ADMINISTRATOR },
      },
      {
        path: '/area-restrita/administrador/ranking-parceiros-externos',
        name: 'administrador-ranking-parceiros-externos',
        component: RankingExterno,
        meta: { userType: UserTypes.ADMINISTRATOR },
      },
      {
        path: '/area-restrita/administrador/whatsapp',
        name: 'administrador-whatsapp',
        component: WhatsApp,
        meta: { userType: UserTypes.ADMINISTRATOR },
      },
      {
        path: '/area-restrita/administrador/app/notificacoes-whatsapp',
        name: 'administrador-app-notificacoes-whatsapp',
        component: ListNotificationWhatsapp,
        meta: { userType: UserTypes.ADMINISTRATOR },
      },
      {
        path: '/area-restrita/administrador/app/construbot-whatsapp',
        name: 'administrador-app-construbot-whatsapp',
        component: ListConstruBotWhatsapp,
        meta: { userType: UserTypes.ADMINISTRATOR },
      },
      {
        path: '/area-restrita/administrador/app/configs',
        name: 'administrador-app-configs',
        component: AppConfigs,
        meta: { userType: UserTypes.ADMINISTRATOR },
      },
      {
        path: '/area-restrita/administrador/construp/notificacoes-whatsapp',
        name: 'administrador-construp-notificacoes-whatsapp',
        component: WhatsAppAdminConstrup,
        meta: { userType: UserTypes.ADMINISTRATOR },
      },
      {
        path: '/area-restrita/administrador/contatos',
        name: 'administrator-contact',
        component: ContactClient,
        meta: { userType: UserTypes.ADMINISTRATOR },
      },
      {
        path: '/area-restrita/administrador/disparar-whatsapp',
        name: 'administrador-disparar-whatsapp',
        component: WhatsAppDisparar,
        meta: { userType: UserTypes.ADMINISTRATOR },
      },
      {
        path: '/area-restrita/administrador/lojistas-por-link',
        name: 'lojistas-por-link',
        component: ARALojistasLink,
        meta: { userType: UserTypes.ADMINISTRATOR },
      },
      {
        path: '/area-restrita/administrador/profissional-site',
        name: 'administrador-profissional-site',
        component: ProfissionalSiteSolicitations,
        meta: { userType: UserTypes.ADMINISTRATOR },
      },
      {
        path: '/area-restrita/administrador/lojistas-app',
        name: 'administrador-lojistas-app',
        component: ShopkeeperAppSolicitations,
        meta: { userType: UserTypes.ADMINISTRATOR },
      },
      {
        path: '/area-restrita/administrador/lojistas-app-version',
        name: 'administrador-version-app',
        component: ShopkeeperAppVersion,
        meta: { userType: UserTypes.ADMINISTRATOR },
      },
      {
        path: '/area-restrita/administrador/lojistas-app/clientes',
        name: 'administrador-lojistas-app-clientes',
        component: Clients,
        meta: { userType: UserTypes.ADMINISTRATOR },
      },
      {
        path: '/area-restrita/administrador/lojistas-app/pedidos',
        name: 'administrador-lojistas-app-pedidos',
        component: OrdersList,
        meta: { userType: UserTypes.ADMINISTRATOR },
      },
      {
        path: '/area-restrita/administrador/lojistas-app/status-pedidos',
        name: 'administrador-lojistas-app-status-pedidos',
        component: OrdersStatusList,
        meta: { userType: UserTypes.ADMINISTRATOR },
      },
      {
        path: '/area-restrita/administrador/lojistas-app/produtos-preco',
        name: 'administrador-lojistas-app-produtos-preco',
        component: SelectedProducts,
        meta: { userType: UserTypes.ADMINISTRATOR },
      },
      {
        path: '/area-restrita/administrador/excluir-fotos-produto',
        name: 'administrador-lojistas-excluir-foto-produto',
        component: DeletePhotoProduct,
        meta: { userType: UserTypes.ADMINISTRATOR },
      },
      {
        path: '/area-restrita/administrador/lojistas-app/arquivos-importacao',
        name: 'administrador-lojistas-app-arquivos-importacao',
        component: SpreadsheetToImportList,
        meta: { userType: UserTypes.ADMINISTRATOR },
      },
      {
        path: '/area-restrita/administrador/lojistas-app/importar-excel',
        name: 'administrador-lojistas-app-importar-excel',
        component: SpreadsheetToImportExcel,
        meta: { userType: UserTypes.ADMINISTRATOR },
      },
      {
        path: '/area-restrita/administrador/lojistas-app/importar-excel-ia',
        name: 'administrador-lojistas-app-importar-excel-ia',
        component: SpreadsheetToImportExcelIa,
        meta: { userType: UserTypes.ADMINISTRATOR },
      },
      {
        path: '/area-restrita/administrador/importar-clientes-excel',
        name: 'administrador-importar-clients-excel',
        component: ImportClientsExcel,
        meta: { userType: UserTypes.ADMINISTRATOR },
      },
      {
        path: '/area-restrita/administrador/enviar-whatsapp-excel',
        name: 'administrador-enviar-whatsapp-excel',
        component: AdministradorEnviarWhatsappExcel,
        meta: { userType: UserTypes.ADMINISTRATOR },
      },
      {
        path: '/area-restrita/administrador/enviar-whatsapp-audio',
        name: 'administrador-enviar-whatsapp-audio',
        component: AdministradorEnviarWhatsappAudio,
        meta: { userType: UserTypes.ADMINISTRATOR },
      },
      {
        path: '/area-restrita/administrador/conversas-whatsapp',
        name: 'administrador-conversas-whatsapp',
        component: AdministradorConversasWhatsapp,
        meta: { userType: UserTypes.ADMINISTRATOR },
      },
      {
        path: '/area-restrita/administrador/lojistas-app/produtos-sugeridos',
        name: 'administrador-lojistas-app-produtos-sugeridos',
        component: ProdutosSugeridos,
        meta: { userType: UserTypes.ADMINISTRATOR },
      },
      {
        path: '/area-restrita/administrador/lojistas-app/produtos-aprovacao',
        name: 'administrador-lojistas-app-produtos-aprovacao',
        component: ProdutosAprovacao,
        meta: { userType: UserTypes.ADMINISTRATOR },
      },
      {
        path: '/area-restrita/administrador/editar-lojista-produto',
        name: 'administrador-editar-lojista-produto',
        component: EditarLojistaProduto,
        meta: { userType: UserTypes.ADMINISTRATOR },
      },
      {
        path: '/area-restrita/administrador/editar-produtos',
        name: 'administrador-lojistas-editar-produtos',
        component: EditarProdutos,
        meta: { userType: UserTypes.ADMINISTRATOR },
      },
      {
        path: '/area-restrita/administrador/solicitacao-saque',
        name: 'list-request-withdraw',
        component: LogListClerk,
        meta: { userType: UserTypes.ADMINISTRATOR },
      },
      {
        path: '/area-restrita/administrador/gerente-vendas',
        name: 'administrador-gerente-vendas',
        component: ARAGerenteVendas,
        meta: { userType: UserTypes.ADMINISTRATOR },
      },
      {
        path: '/area-restrita/administrador/impersonate',
        name: 'administrador-impersonate',
        component: () =>
          import('../../views/administrador/impersonate/Index.vue'),
        meta: { userType: UserTypes.ADMINISTRATOR },
      },
    ],
  },
];
